import { Tooltip } from "antd";
import SVG from "components/common/SVG";

import styles from "./style.module.scss";

const ActionsContainer = ({ updateUserRole, setShowRemoveUserModal }) => {
  return (
    <div className={styles.actionContainer}>
      <Tooltip placement="top" title={"Update User Role"} arrow>
        <button className={styles.updateCta} onClick={updateUserRole}>
          Update
        </button>
      </Tooltip>

      <Tooltip placement="top" title={"Remove User"} arrow>
        <div className={styles.item} onClick={setShowRemoveUserModal}>
          <SVG className={styles.actionIcon} iconName={"images/remove.svg"} />
        </div>
      </Tooltip>
    </div>
  );
};

export default ActionsContainer;
